module.exports = __webpack_public_path__ + "img/FAD.c6f52129.png";